import type { ComponentProps, FC } from 'react';
import { SvgIcon } from './SvgIcon';

type Props = ComponentProps<typeof SvgIcon>;

const Icon: FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 5.83827C13.9642 5.9429 13.6554 6 13.3333 6C13.2632 6 13.1937 5.99729 13.125 5.99198V13.125H2.875V2.875H10.7059C10.778 2.45902 10.9464 2.07607 11.1874 1.75H2.25C1.97344 1.75 1.75 1.97344 1.75 2.25V13.75C1.75 14.0266 1.97344 14.25 2.25 14.25H13.75C14.0266 14.25 14.25 14.0266 14.25 13.75V5.83827Z"
        fill="black"
      />
      <path
        d="M13.333 5.33325C14.4376 5.33325 15.333 4.43782 15.333 3.33325C15.333 2.22868 14.4376 1.33325 13.333 1.33325C12.2284 1.33325 11.333 2.22868 11.333 3.33325C11.333 4.43782 12.2284 5.33325 13.333 5.33325Z"
        fill="black"
      />
    </svg>
  );
};

export const CommentUnreadIcon: FC<Props> = (props) => {
  return <SvgIcon size={16} component={Icon} {...props} />;
};
